import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import Pagination from './Pagination';
import { searchClients } from '../../api'; // Asume que ya existe la función searchClients en tu API
import ClientSearchForm from './ClientSearchForm'; // Asegúrate de importar el formulario de búsqueda
import SortableHeader from '../ui/SortableHeader';
import { useSorting } from '../../hooks/useSorting';
import { isPropietarioOrAdminOrGestion, isJefeComerciales } from '../../services/AuthService';
import TotalCount from './TotalCount';

const ClientSearchModal = ({ show, onHide, onClientSelect, userRole, excludeDisabled = false }) => {
  const [clients, setClients] = useState([]); // Para almacenar los resultados de la búsqueda
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState({});
  const showSalesRepColumn = isPropietarioOrAdminOrGestion() || isJefeComerciales();
  const { handleSort, getSortIcon } = useSorting();

  // Cargar clientes según los criterios de búsqueda
  useEffect(() => {
    if (show) { // Solo cuando el modal está visible
      const fetchClients = async () => {
        try {
          const results = (await searchClients(searchCriteria, currentPage, itemsPerPage, !excludeDisabled)).data;
          setClients(results.items);  // Guardamos los clientes
          setTotalCount(results.totalCount); // Guardamos el total de clientes
        } catch (error) {
          console.error("Error fetching clients:", error);
        }
      };

      fetchClients();
    }
  }, [show, currentPage, itemsPerPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);  // Reseteamos a la primera página
  };

  const handleClientSelect = (client) => {
    onClientSelect(client);  // Pasamos el cliente seleccionado al componente principal
    onHide(); // Cerramos el modal
  };

  const handleSearch = async (criteria) => {
    setCurrentPage(1);
    try {
      const results = (await searchClients(criteria, 1, itemsPerPage, !excludeDisabled)).data;
      setClients(results.items);
      setTotalCount(results.totalCount);
    } catch (error) {
      console.error('Error fetching clients:', error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Seleccionar Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {/* Componente de búsqueda */}
        <ClientSearchForm onSearch={handleSearch} userRole={userRole} excludeDisabled={excludeDisabled} />

        <div className="d-flex justify-content-end mb-2">
          <TotalCount totalCount={totalCount} />
        </div>

        <Table striped bordered hover>
          <thead>
            <tr>
              {showSalesRepColumn && <SortableHeader column="salesRep.name" onSort={handleSort} getSortIcon={getSortIcon}>Comercial</SortableHeader>}
              <SortableHeader column="name" onSort={handleSort} getSortIcon={getSortIcon}>Nombre</SortableHeader>
              <SortableHeader column="lastName1" onSort={handleSort} getSortIcon={getSortIcon}>Apellido</SortableHeader>
              <SortableHeader column="phone" onSort={handleSort} getSortIcon={getSortIcon}>Teléfono</SortableHeader>
              <SortableHeader column="email" onSort={handleSort} getSortIcon={getSortIcon}>Email</SortableHeader>
              <th>Seleccionar</th>
            </tr>
          </thead>
          <tbody>
            {clients.length > 0 ? (
              clients.map((client) => (
                <tr key={client.id}>
                  {showSalesRepColumn && (
                    <td>
                      {client.salesRep
                        ? `${client.salesRep.name} ${client.salesRep.lastName1}`
                        : 'Sin asignar'}
                    </td>
                  )}
                  <td>{client.name}</td>
                  <td>{client.lastName1}</td>
                  <td>{client.phone}</td>
                  <td>{client.email}</td>
                  <td>
                    <Button
                      variant="success"
                      onClick={() => handleClientSelect(client)}
                    >
                      Seleccionar
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No se encontraron resultados.</td>
              </tr>
            )}
          </tbody>
        </Table>

        <Pagination
          totalCount={totalCount}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientSearchModal;
